import React, {useState} from 'react'
import { createPortal } from 'react-dom';
import LoadingMessages from '../components/_common/LoadingMessages'
import { useLayoutData } from './useLayoutData'
import {Button, Modal} from "@material-ui/core";

// const rootElement = document.getElementById('root') as HTMLElement;
const Footer = () => {
  const [isOpenModal, setOpenModal] = useState(false);
  const actualYear = new Date().getFullYear()

  const layoutData = useLayoutData()
  if (!layoutData) {
    return <LoadingMessages/>
  }
  const { footerMenu, socialIconLinks, bottomMenu } = layoutData

  /*const openModal = () => {
    setOpenModal(true);
  }

  const closeModal = () => {
    setOpenModal(false);
  }*/

  const triggerModal = () => {
    setOpenModal(prev => !prev);
  };

  return (
    <footer className="sukl-footer noprint">
      <div className="footer-inner">
        <div className="footer-upper">
          <a href="https://testweb.sukl.cz/" aria-label="SÚKL">
            <img alt="SÚKL - logo" className="sukl-logo" src="/sukl-white.svg" width="134" height="44" loading="lazy"/>
          </a>
          <div className="footer-menu">
            <div>
              <ul className="footer-menu-list">
                {footerMenu[0].links.map((item, index) => (
                  <li key={index}>
                    <a href={item.path} aria-label={item.text}>{item.text}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <ul className="footer-menu-list">
                {footerMenu[1].links.map((item, index) => (
                  <li key={index}>
                    <a href={item.path} aria-label={item.text}>{item.text}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-right-menu-social">
              <div className="gov-footer__infoline">
                <div className="gov-footer__infoline--wrapper">
                  <span>
                      INFOLINKA
                  </span>
                  <a href="tel:272185333" aria-label="INFOLINKA plus 420, 272, 185, 333"
                     className="gov-footer__infoline-link">
                    272 185 333
                  </a>
                </div>
                <div>
                  Po–Pá 9:00 až 14:00
                </div>
              </div>
              <p>{socialIconLinks.name}</p>
              <ul className="social-list">
                {socialIconLinks.links.map((item, index) => (
                    <li key={index}>
                      <a href={item.path} aria-label={item.ariaLabel}>
                        <svg className="social-icons" width="24px" height="24px" fill="white">
                          <title>{item.ariaLabel + ' - logo'}</title>
                          <use href={`/socials.svg#${item.iconClassName}`}></use>
                        </svg>
                      </a>
                    </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <hr/>

        <div className="footer-lower">
          <p className="footnote">© {actualYear} SÚKL všechna práva vyhrazena</p>
          <p className="footnote">
            {bottomMenu.map((item, index) => (
              <span key={index}>
                <a href={item.path}> {item.text} </a>
                <span> | </span>
              </span>
            ))}
            <button className="btn-footnote" onClick={triggerModal}>Nastavení cookies</button>
          </p>
        </div>

        <button className="btn-scroll-up"
                onClick={() => {
                  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                }}
        >
          <span> Zpět nahoru </span>
          <i className="fas fa-angle-up"></i>
        </button>
      </div>

      {createPortal(
        <Modal open={isOpenModal}>
          <div className="modal-dialog finalmodalbox">
            <div className="modal-content">
              <div className="modal-body" style={{fontWeight: 400, color: "#3b3b3b"}}>
                <i className="fa fa-cookie-bite"></i>
                <h3>Informace o používání cookies</h3>
                <p>
                  Na webu formulare.sukl.gov.cz jsou použity pouze technické cookies, které jsou nezbytné pro správné
                  fungování webových stránek. Tyto cookies neukládají žádné osobní údaje a nejsou využívány
                  k marketingovým účelům. Používání technických cookies je v souladu s platnými legislativními předpisy.
                </p>
                <Button variant="outlined" color="inherit" className={'mt-4'} onClick={triggerModal}>Rozumím</Button>
              </div>
            </div>
          </div>
        </Modal>,
        document.body
        // rootElement
      )}

    </footer>
  )
}

export default Footer
